<template>
    <transition name="modal">
        <div class="dialog-modal-mask">
            <div class="marker-panel">
                <div class="dialog-title" v-t="{ path: 'message.title_map_icon_change', args: { userName: mapMarkerParam.displayName } }">
                </div>
                <hr class="dialog-hr">
                <div class="marker-panel-body">
                    <div style="padding:10px 20px">
                        <div class="sys-icon-desc" v-t="'message.desc_map_icon_change'"></div>
                        <table style="width: 100%;table-layout: fixed;margin-top: 10px">
                            <span v-for="markerRecord in markerList">
                                <tr class="marker-icon-record">
                                    <span v-for="markerUrl in markerRecord">
                                        <td v-if="isSelected(markerUrl)" class="marker-icon">
                                            <button class="marker-selected" type="button" v-on:click="handleSelectedIcon(markerUrl)"><img :src=markerUrl class="marker-icon"/></button>
                                        </td>
                                        <td v-else class="marker-icon">
                                            <button class="marker-non-selected" type="button" v-on:click="handleSelectedIcon(markerUrl)"><img :src=markerUrl class="marker-icon"/></button>
                                        </td>
                                    </span>
                                </tr>
                            </span>
                        </table>
                        <el-checkbox class="checkbox" style="padding-top:10px;" v-model="useOriginalMarker" @change="handleUseUserMarker()">
                            <span  v-t="'message.item_map_icon_custom'"></span>
                        </el-checkbox>
                        <div style="padding-left: 25px" v-t="'message.hint_map_icon_custom'"></div>
                        <div>
                            <el-form label-width="0px" style="padding-left:20px;">
                                <el-form-item ref="iconUrl">
                                    <el-input style="padding: 10px 0px;width: 470px" type="text" @input.native="inputCheck()" v-model="inputForm.value"
                                        @compositionstart.native="compositionStart()" @compositionend.native="compositionEnd()"
                                        placeholder="https://www.sample.com/xxxxxx/image.png"></el-input>
                                </el-form-item>
                            </el-form>
                        </div>
                        <el-checkbox class="checkbox" v-model="useDefaultMarker" @change="handleUseDefaultMarker()">
                            <span v-t="'message.item_map_icon_default'"></span>
                        </el-checkbox>
                    </div>
               </div>
                <hr class="dialog-hr">
                <div class="dialog-button-field">
                    <el-button type="button" class="dialog-cancel-button" @click="$emit('cancel')" v-t="'message.button_cancel'"></el-button>
                    <el-button class="dialog-ok-button" :disabled="this.disableButton" @click="saveIcon()" v-t="'message.button_save'"></el-button>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import commonUtil from './commonutil.js';
import commonValidate from './common-validate.js';
import constants from './constants.js';

export default {
    props: [ 'mapMarkerParam' ],
    data() {
        return {
            fireFox: false,
            inputForm: { validationRule: "reqUrl", valid: true, value: null, isComposing: false },
            markerList: [],
            selectedIconUrl: "not selected",
            useOriginalMarker: false,
            useDefaultMarker: false,
            disableButton: false,
        }
    },
    methods: {
        setButtonStatus() {
            if (this.useOriginalMarker) {
                if (this.inputForm.valid) {
                    this.disableButton = false;
                } else {
                    this.disableButton = true;
                }
            } else {
                if (this.useDefaultMarker) {
                    this.disableButton = false;
                } else {
                    if (this.selectedIconUrl == "not selected") {
                        this.disableButton = true;
                    } else {
                        this.disableButton = false;
                    }
                }
            }
        },
        inputCheck() {
            if (!this.useOriginalMarker) {
                if (this.inputForm.value.length > 0) {
                    this.inputForm.valid = false;
                    this.$refs.iconUrl.validateState = "error";
                    this.$refs.iconUrl.validateMessage = commonUtil.getMessageText(this.$i18n,"error_validate_custom_icon_not_checked");
                    this.disableButton = true;
                    return;
                }
            }
            if (this.inputForm.isComposing) {
                // inputting with IME
                return;
            }
            let validateResult = commonValidate.validateItem(this.$i18n, this.inputForm.validationRule, this.inputForm.value);
            if (validateResult.valid) {
                this.$refs.iconUrl.clearValidate();
                this.inputForm.valid = true;
            } else {
                this.inputForm.valid = false;
                this.$refs.iconUrl.validateState = "error";
                this.$refs.iconUrl.validateMessage = validateResult.message;
            }
            this.setButtonStatus();
        },
        handleSelectedIcon(markerUrl) {
            this.selectedIconUrl = markerUrl;
            this.useOriginalMarker = false;
            this.inputForm.value = "";
            this.$refs.iconUrl.clearValidate();
            this.inputForm.valid = true;
            this.useDefaultMarker = false;
            this.setButtonStatus();
        },
        handleUseUserMarker() {
            if (this.useOriginalMarker) {
                this.inputCheck();
                this.selectedIconUrl = "not selected";
                this.useDefaultMarker = false;
            } else {
                this.inputForm.value = "";
                this.$refs.iconUrl.clearValidate();
                this.inputForm.valid = true;
                this.setButtonStatus();
            }
        },
        handleUseDefaultMarker() {
            if (this.useDefaultMarker) {
                this.selectedIconUrl = "not selected";
                this.useOriginalMarker = false;
                this.inputForm.value = "";
                this.$refs.iconUrl.clearValidate();
                this.inputForm.valid = true;
            }
            this.setButtonStatus();
        },
        isSelected(markerUrl) {
            if (markerUrl == "") {
                return false;
            }
            if (this.selectedIconUrl == markerUrl) {
                return true;
            } else {
                return false;
            }
        },
        saveIcon() {
            if (this.useDefaultMarker) {
                this.$emit("change", "");
                return;
            }

            let iconUrl;
            if (this.useOriginalMarker) {
                iconUrl = this.inputForm.value;
            } else {
                iconUrl = this.selectedIconUrl;
            }
            this.$emit("change", iconUrl);
        },
        compositionStart() {
            this.inputForm.isComposing = true;
        },
        compositionEnd() {
            this.inputForm.isComposing = false;
            this.inputCheck()
        },
    },
    created() {
        var userAgent = window.navigator.userAgent.toLowerCase();
        if(userAgent.indexOf('firefox') != -1) {
            this.fireFox = true;
        }
        this.markerList = commonUtil.getMarkerIconList();
        if (this.mapMarkerParam.iconUrl != "") {
            if (this.mapMarkerParam.iconUrl.indexOf(constants.ICON_IMAGE_PATH) >= 0) {
                this.selectedIconUrl = this.mapMarkerParam.iconUrl;
            } else {
                this.useOriginalMarker = true;
                this.inputForm.value = this.mapMarkerParam.iconUrl;
            }
        } else {
            this.useDefaultMarker = true;
        }
    }
}
</script>
<style scoped>
button.marker-selected {
    padding-top: 1px;
    border: solid 1px #5171cb;
    background-color: transparent;
    cursor: pointer;
    outline: none;
}
button.marker-selected:active {
    /* for firefox -- prevent the moving a icon when clicked -- */
    padding-left: 6px;
    padding-right: 6px;
}
button.marker-non-selected {
    padding-top: 1px;
    border: solid 1px #fff;
    background-color: transparent;
    cursor: pointer;
    outline: none;
}
button.marker-non-selected:active {
    /* for firefox -- prevent the moving a icon when clicked -- */
    padding-left: 6px;
    padding-right: 6px;
}
img.marker-icon {
    margin-top: 1px;
    height: 36px;
    width: 36px;
}
img.marker-icon:active {
    margin-top: 1px;
}
.marker-panel {
    background: #fff;
    position: absolute;
    padding: 0;
    transition: all .3s ease;
    border-radius: 4px;
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
    -webkit-overflow-scrolling: touch;
    overflow: hidden;
    width: 600px;
    max-height: 62vh;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
}
.marker-panel-body {
    height: calc(62vh - 140px);
    padding: 0;
    font-size: 14px;
    overflow-y: scroll;
    overflow-x: hidden;
}
.marker-icon {
    vertical-align: middle;
    text-align: center;
    width: 65px;
    padding: 5px 0;
}
.marker-icon-record {
    display: block;
    padding-left: 12px;
}
.sys-icon-desc {
    padding: 10px 20px;
    color: #848991;
    background-color: #f6f6f6;
    font-size: 12px;
}
.checkbox.el-checkbox {
    margin: 0;
}
.checkbox >>> .el-checkbox__input.is-checked+.el-checkbox__label {
    color:#5171cb
}
.checkbox >>> .el-checkbox__input.is-checked .el-checkbox__inner,
.checkbox >>> .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #5171cb;
    border-color: #5171cb
}

</style>
